if (!window.retailer) {
    window.retailer = {};
}

!function (retailer, debug) {
    retailer.randomInt = function () {
        return Math.floor(Math.random() * (Number.MAX_SAFE_INTEGER - Number.MIN_SAFE_INTEGER + 1)) + Number.MIN_SAFE_INTEGER;
    };

    retailer.isIE = function () {
        let myNav = navigator.userAgent.toLowerCase();
        return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
    };

    retailer.isIOS = function () {
        return (navigator.userAgent.match(/(iPad|iPhone|iPod)/g));
    };

    retailer.emptySelection = function () {
        if (debug) { console.log('in emptyselection'); }
        let sText = '';
        if (window.getSelection && (retailer.isIE() === false)) {
            if (debug) { console.log('currentSelection: ', window.getSelection().toString()); }
            sText = window.getSelection().toString();
            if (window.getSelection().empty) {  // Chrome
                window.getSelection().empty();
            } else if (window.getSelection().removeAllRanges) {  // Firefox
                window.getSelection().removeAllRanges();
            }
        }
        else if (document.selection) {  // IE?
            if (debug) { console.log('document.selection, IE'); }
            if (debug) { console.log('currentSelection: ', document.selection); }
            if (debug) { console.log('html text: ', document.selection.createRange().htmlText); }
            if (debug) { console.log('text: ', document.selection.createRange().text); }
            sText = document.selection.createRange().htmlText;
            document.selection.empty();
        }
        return sText;
    };

    retailer.makeTableClipboard = function (btn) {
        if (debug) { console.log('in maketableclipboard', btn); }

        let clipboard = new ClipboardJS(btn);

        clipboard.on('success', function (e) {
            if (debug) {
                console.info('Action:', e.action);
                console.info('Text:', e.text);
                console.info('Trigger:', e.trigger);
            }

            e.clearSelection();
        });

        clipboard.on('error', function (e) {
            console.error('Action:', e.action);
            console.error('Text:', e.text);
            console.error('Trigger:', e.trigger);
        });

        return clipboard;
    };

    // retailer.makeTableClipboard = function ($dom, table) {
    //     if (debug) { console.log('in maketableclipboard'); }
    //     retailer.makeTableClipboard.table = table;

    // let options = {
    //     moviePath: '/swf/ZeroClipboard.swf'
    // };
    // ZeroClipboard.setDefaults(options);
    // let clip = new ZeroClipboard($dom);

    // clip.on("load", function (client) {

    //     clip.on('dataRequested', function () {
    //         if (debug) console.log('in clipboard datarequested');
    //         if (debug) console.log(retailer.makeTableClipboard.table);
    //         retailer.selectTable(retailer.makeTableClipboard.table);
    //         let sText = retailer.emptySelection();
    //         client.setText(sText);
    //     });

    //     client.on("complete", function (client, args) {
    //         // `this` is the element that was clicked
    //         // $('.copyTableTooltip').fadeIn(400).fadeOut(2000);
    //         //var options = {};
    //         $(this).tooltip('show');
    //         (function (el) {
    //             setTimeout(function () {
    //                 $(el).tooltip('hide');
    //             }, 1000);
    //         })(this);
    //         if (debug) { console.log("Copied text to clipboard: ", args); }
    //         if (debug) { console.log($(this)); }

    //         return true;
    //     });

    //     clip.on('mouseover', function (client, args) {
    //         $(this).addClass('active');
    //     });

    //     clip.on('mouseout', function (client, args) {
    //         $(this).removeClass('active');
    //     });

    //     clip.on('noflash', function (client, args) {
    //         alert("You don't support flash. Copy-to-clipboard will not work.");
    //     });

    //     clip.on('wrongflash', function (client, args) {
    //         alert("Your flash is too old " + args.flashVersion + '. Copy-to-clipboard will not work.');
    //     });

    // });

    // return clip;
    // };

    retailer.selectTable = function (el) {
        let body = document.body, range, sel;
        if (document.createRange && window.getSelection) {
            range = document.createRange();
            sel = window.getSelection();
            sel.removeAllRanges();
            try {
                range.selectNodeContents(el);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(el);
                sel.addRange(range);
            }
        } else if (body.createTextRange) {
            range = body.createTextRange();
            range.moveToElementText(el);
            range.select();
        }
    };

    retailer.log = function () {
        if (retailer.debug) {
            for (let i = 0; i < arguments.length; i++) {
                console.log(arguments[0]);
            }
        }
    };

    retailer.validateEmail = function (email) {
        return /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
            .test(email);
    };

    retailer.isInt = function (value) {
        return /^-?(0|[1-9]\d*)$/.test(value);
    };

    retailer.processCreateCompetitionInputs = function (formInputs) {
        if (!formInputs.competition_id || formInputs.competition_id == '' ||
            formInputs.is_enabled == '' || formInputs.open_to_public == '' || formInputs.open_to_teachers == '') {
            return "You need to fill up all required fields.";
        }
        let seeds = [];
        if (formInputs.isRobot) {
            if (!retailer.isInt(formInputs.rounds)) return 'Check number of rounds. It needs to be valid integers';
            let rounds = parseInt(formInputs.rounds);
            if (rounds > 10000) return 'Check number of rounds. It cannot be larger than 10,000';
            for (let i = 0; i < rounds; i++) {
                if (formInputs.seed_type == "fixed") {
                    let seed = retailer.randomInt();
                    while (!seed) seed = retailer.randomInt();
                    seeds[i] = seed;
                } else {
                    seeds[i] = 0;
                }
            }
        } else {
            for (let i = 0; i < 5; i++) {
                let seed = formInputs['seed-' + i];
                if (!retailer.isInt(seed)) return 'Check your seeds. They need to be valid integers';
                seeds[i] = parseInt(seed);
            }
        }
        formInputs.competition_id = formInputs.competition_id.toUpperCase();
        let result = {
            competition_id: formInputs.competition_id
            , open_to_public: formInputs.open_to_public != 'false'
            , open_to_teachers: formInputs.open_to_teachers != 'false'
            , is_enabled: formInputs.is_enabled != 'false'
            , isRobot: formInputs.isRobot
            , seeds: seeds
        };
        if (formInputs.open_to_public == 'false' && formInputs.emails != null && formInputs.emails != '') {
            let emails = new Set();
            let emailsText = formInputs.emails.split(',');
            for (let i = 0; i < emailsText.length; i++) {
                if (retailer.validateEmail(emailsText[i].toLowerCase().trim())) {
                    emails.add(emailsText[i].toLowerCase().trim());
                } else {
                    return "Check your allowed email addresses, they need to be valid";
                }
            }
            result.emails = Array.from(emails);
        }
        return result;
    };
    function main() {

    }
    main();
}(window.retailer, window.retailer.debug);



// WEBPACK FOOTER //
// ../public/js/retailer.helper.js